import * as React from 'react';
import * as Routes from '../../Routes';

interface Props {
  Restaurant: Routes.RouteRestaurant;
  InsideDeliveryZone: boolean;
  translate: any;
}

interface State {}

// TODO - use a stateless component
class ClosedAlert extends React.Component<Props, State> {
  public render(): JSX.Element | null {
    const { Restaurant, InsideDeliveryZone, translate } = this.props;

    switch (Restaurant.status) {
      case 'none':
      case 'pending':
        return null;
      case 'success':
        break;
    }

    if (InsideDeliveryZone && Restaurant.data.IsOpen) {
      return null;
    }

    if (!InsideDeliveryZone) {
      return (
        <div className="closed-alert" tabIndex={0}>
          <h3 className="clear-margin-top">
            {translate('Cannot_deliver', {
              restaurantName: Restaurant.data.RestaurantName
            })}
            <span style={{ fontSize: '80%', display: 'block' }}>
              {translate('Does_not_deliver')}
            </span>
          </h3>
        </div>
      );
    }

    let preOrder = '';

    if (Restaurant.data.AcceptPreOrders) {
      preOrder = ` - ${translate('Preorder_only')}`;
    }

    return (
      <div className="closed-alert" tabIndex={0}>
        <h3 className="clear-margin-top">
          {`${translate('Is_closed', {
            restaurantName: Restaurant.data.RestaurantName
          })}${preOrder}`}
          <span style={{ fontSize: '80%', display: 'block' }}>
            {Restaurant.data.OpenTimeMessage}
          </span>
        </h3>
      </div>
    );
  }
}

export default ClosedAlert;
